'use client';

import { Flexbox } from '@doc/ui-components';
import { useTranslations } from '@power-core/toolkit';
import { useTheme } from 'next-themes';
import BackupImage from '@/assets/backup_card.svg';
import BackupImageDark from '@/assets/backup_card_dark.svg';
import SelectivityImage from '@/assets/selectivity_card.svg';
import SelectivityImageDark from '@/assets/selectivity_card_dark.svg';
import type { ToolCardProps } from '@/features/tool-card/types/tool-card.type';
import { ToolCard } from '@/features/tool-card/ui/tool-card.ui';
import { useGetProjectData } from '@/shared/project/hooks/use-get-project-data.hook';
import { BackdropLoading } from '@/shared/ui-components/backdrop-loading.ui';

export default function HomePage() {
	const t = useTranslations();
	const { isPending } = useGetProjectData();
	const { resolvedTheme } = useTheme();

	const TOOLS: ToolCardProps[] = [
		{
			text: t('T_SELECTIVITY'),
			link: 'selectivity',
			icon: resolvedTheme === 'dark' ? <SelectivityImageDark /> : <SelectivityImage />,
			tooltipText: t('T_SELECTIVITY_INFO'),
		},
		{
			text: t('T_BACKUP'),
			link: 'backup',
			icon: resolvedTheme === 'dark' ? <BackupImageDark /> : <BackupImage />,
			tooltipText: t('T_BACKUP_INFO'),
		},
	];

	if (isPending) return <BackdropLoading />;

	return (
		<Flexbox direction='col' items='center' className='h-full' justify='center'>
			<div className='grid grid-cols-2 grid-rows-2 gap-2 lg:gap-4 xl:gap-8 w-3xl lg:w-4xl xl:w-6xl'>
				{TOOLS.map((tool) => (
					<ToolCard key={tool.link} {...tool} />
				))}
			</div>
		</Flexbox>
	);
}
